import { render } from "./MModifiedData.vue?vue&type=template&id=3a535986&scoped=true"
import script from "./MModifiedData.vue?vue&type=script&lang=js"
export * from "./MModifiedData.vue?vue&type=script&lang=js"

import "./MModifiedData.vue?vue&type=style&index=0&id=3a535986&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a535986"]])

export default __exports__